module.exports = __webpack_public_path__ + "img/genggo-head.3f8e298c.png";